var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIconHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19.75H21V21.75H3V19.75ZM13 13.922L19.071 7.85L20.485 9.264L12 17.75L3.515 9.265L4.929 7.85L11 13.923V2.75H13V13.922Z",
    fill: "#4642ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconHover);
export default __webpack_public_path__ + "static/media/download_icon_hover.1a097bc13f5aba1f07c96dcf3e93ccbc.svg";
export { ForwardRef as ReactComponent };